import { AxiosInstance } from 'axios';
import { CommunicationNotebooksRepository } from '@/model/repository/manager/childcare-document/CommunicationNotebooksRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): CommunicationNotebooksRepository => ({
    getAllApproved(payload) {
      return Repository.get(`${resource}/approved`, { params: payload });
    },
  });
